import { Injectable, ElementRef } from '@angular/core';

export interface IFlyout {
    isVisible:boolean;
    isActive:boolean;
    animationElement:ElementRef;
}
@Injectable({providedIn:'root'})
export class FlyoutService {

    constructor() { }

    public create():IFlyout {
        return { isVisible:false, isActive:false, animationElement:null };
    }
    public toggleVisible=(flyout:IFlyout,mutualExclusive:IFlyout=null)=> {
        if (mutualExclusive && mutualExclusive.isVisible) { this.toggleVisible(mutualExclusive);}
        const newVisible = !flyout.isVisible;
        if (newVisible) {
            this.show(flyout);
        } else {
            this.hide(flyout);
        }
    }

    public clearAll(flyouts:IFlyout[]) {
        flyouts
            .filter(f=>f.isVisible)
            .forEach(f=>{this.hide(f);f.isVisible=false;});
    }
 
    private show(flyout:IFlyout) {
        flyout.isVisible=true;
        setTimeout(()=>{
            flyout.isActive=true;
        },0);
    }
    private hide(flyout:IFlyout) {
        flyout.animationElement.nativeElement.addEventListener('transitionend',($event:any)=>{
            setTimeout(()=>{flyout.isVisible=false;},0);
        },{once:true});
        flyout.isActive=false;
    }
    
}
